<template>
<div>
    <div id="dhk" class="gotop" v-show="gotop">
        <a id="kefu" href="http://p.qiao.baidu.com/cps/chat?siteId=15881909&userId=31219776&siteToken=ab257d7b559bd01f6df8a87638c32e10" @mouseenter="enter()" @mouseleave="leave()" target="_blank">
            <img v-if="isShow" class="pic" src="@/assets/img/kefu.png" alt="">
            <img v-if="!isShow" class="pic" src="@/assets/img/kefu-active.png" alt="">
            <p class="h2">在线客服</p>
        </a>
        <a id="zhuanjia" style="border-top: 0;" href="javascript:;" @mouseenter="enter1()" @mouseleave="leave1()">
            <img v-if="isShow1" class="pic" src="@/assets/img/phone.png" alt="">
            <img v-if="!isShow1" class="pic" src="@/assets/img/phone-active.png" alt="">
            <p class="h2">APP下载</p>
        </a>
        <a id="top" style="border-top: 0;" href="javascript:;" @mouseenter="enter2()" @mouseleave="leave2()" @click="toTop">
            <img v-if="isShow2" class="pic" src="@/assets/img/top.png" alt="">
            <img v-if="!isShow2" class="pic" src="@/assets/img/top-active.png" alt="">
            <p class="h2">回顶部</p>
        </a>
    </div>
    <div class="ewm" v-show="isShow3">
        <img src="http://www.haichacha.net/wechat.jpg" alt="">
        <p>下载<a href="javascript:;"> 海查查app</a>，更多数据查阅</p>
    </div>
</div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            isShow: true,
            isShow1: true,
            isShow2: true,
            isShow3: false,
            gotop: false
        };
    },
    computed: {},
    watch: {},
    methods: {
        enter() {
            this.isShow = !this.isShow;
        },
        leave() {
            this.isShow = true;
        },
        enter1() {
            this.isShow1 = !this.isShow1;
            this.isShow3 = !this.isShow3;
        },
        leave1() {
            this.isShow1 = true;
            this.isShow3 = false;
        },
        enter2() {
            this.isShow2 = !this.isShow2;
        },
        leave2() {
            this.isShow2 = true;
        },
        handleScroll() {
            let scrolltop =
                document.documentElement.scrollTop || document.body.scrollTop;
            scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
        },
        toTop() {
            let top = document.documentElement.scrollTop || document.body.scrollTop;
            // 实现滚动效果
            var timer = setInterval(function () {
                //当前距离顶部的高度
                let osTop =
                    document.documentElement.scrollTop || document.body.scrollTop;
                //速度：当前滚动的高度/5 加上-号 和 去除小数 就是速度 这个值在缓冲过程中会越来越小
                //例如 滚动到3000时 点击回到顶部 这个时候 开始第一次滚动 每30毫米滚动的距离是3000-600=2400
                // 第二次滚动 每30毫秒滚动距离2400-480=1920
                // 第三次 每30毫秒滚动距离1920-384=1536
                //。。。。。。依次递减
                let ispeed = Math.floor(-osTop / 5);
                //开始滚动 osTop+(-速度)=osTop-速度
                document.documentElement.scrollTop = document.body.scrollTop =
                    osTop + ispeed;
                this.isTop = true;
                //滚动距离为0清除计时器
                if (osTop === 0) {
                    clearInterval(timer);
                }
                // console.log(document.documentElement.scrollTop);
                //过渡动画的速度 数值过大会出现卡顿现象
            }, 0);
        }
    },
    created() {},
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
    }
};
</script>

<style lang="less" scoped>
#dhk {
    width: 70px;
    height: 210px;
    transition: all 0.5s;
    position: fixed;
    right: 0;
    top: 50%;
    margin-top: -105px;
    z-index: 9999;
    display: flex;
    flex-direction: column;

    a {
        width: 70px;
        height: 70px;
        display: block;
        border: solid 1px #eeeeee;
        background: #ffffff;

        // overflow: hidden;
        img {
            margin: 13px auto 3px;
        }

        .h2 {
            font-size: 12px;
            letter-spacing: 0px;
            color: #666666;
            text-align: center;
        }
    }

    a:hover {
        background-color: #ff6613;

        .h2 {
            color: #ffffff;
        }
    }
}

.ewm {
    width: 200px;
    height: 240px;
    background: #ffffff;
    box-shadow: 3px 1px 9px 0px rgba(5, 53, 108, 0.11);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: fixed;
    right: 90px;
    top: 50%;
    margin-top: -120px;

    img {
        width: 85%;
    }

    p {
        font-size: 12px;
        color: #464646;
        padding-top: 12px;

        a {
            color: #004ecf;
        }
    }
}
</style>
